// auto-add-gift.js
const FREE_PRODUCT_ID = 8145638850728; // Your Icy Mix product ID
const THRESHOLD = 10000000; // $100000 in cents

function checkCartAndAddGift() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartTotal = cart.total_price;
            const hasFreeProduct = cart.items.find(item => item.id === FREE_PRODUCT_ID);
            
            console.log('Cart total:', cartTotal, 'Has free product:', hasFreeProduct);
            
            // Add free product if threshold met and not already in cart
            if (cartTotal >= THRESHOLD && !hasFreeProduct) {
                addProductToCart();
            }
            // Remove free product if threshold not met but product is in cart
            else if (cartTotal < THRESHOLD && hasFreeProduct) {
                removeProductFromCart(hasFreeProduct.id);
            }
        });
}

function addProductToCart() {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: [{
                id: FREE_PRODUCT_ID,
                quantity: 1
            }]
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Free product auto-added!');
        // Refresh cart drawer
        if (typeof Shopify === 'object' && Shopify.onCartUpdate) {
            Shopify.onCartUpdate();
        }
    })
    .catch(error => console.error('Error:', error));
}

function removeProductFromCart(productId) {
    const updates = {};
    updates[productId] = 0;
    
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates })
    })
    .then(() => {
        console.log('Free product removed');
        if (typeof Shopify === 'object' && Shopify.onCartUpdate) {
            Shopify.onCartUpdate();
        }
    });
}

// Check cart every time it changes
document.addEventListener('DOMContentLoaded', function() {
    // Check initially
    checkCartAndAddGift();
    
    // Check when cart updates
    document.addEventListener('cart:updated', checkCartAndAddGift);
    document.addEventListener('cart:change', checkCartAndAddGift);
    
    // Also check every 2 seconds (fallback)
    setInterval(checkCartAndAddGift, 2000);
});